// extracted by mini-css-extract-plugin
export default {"container":"Header_container__dNr6m","titleName":"Header_titleName__90tZb","loguotButton":"Header_loguotButton__k9wWL"};